// Module
var code = `<!-- Event Edit Modal -->
<!-- The .modal element acts as the backdrop (same pattern as main calendar modal) -->
<div class="modal fade z-index-modal-nested nested-modal-backdrop" ng-class="{'show': \$ctrl.show}"
  ng-style="{'display': \$ctrl.show ? 'block' : 'none'}" ng-click="\$ctrl.cancel()" tabindex="-1" role="dialog"
  aria-labelledby="eventEditModalLabel" ng-attr-aria-hidden="{{!\$ctrl.show}}">
  <div class="modal-dialog" role="document" ng-click="\$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="eventEditModalLabel">
          <i class="fas fa-edit"></i> Edit Interval
        </h5>
        <button type="button" class="btn-close" ng-click="\$ctrl.cancel()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form ng-if="\$ctrl.localEvent" ng-submit="\$ctrl.save()">
          <div class="mb-3">
            <label for="event-name" class="form-label">Scene Collection</label>
            <input type="text" id="event-name" class="form-control" ng-model="\$ctrl.localEvent.title" disabled />
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="event-start-date" class="form-label">Start Date</label>
                <input type="date" id="event-start-date" class="form-control" ng-model="\$ctrl.localEvent.startDate"
                  required />
              </div>
              <div class="mb-3">
                <label for="event-start-time" class="form-label">Start Time</label>
                <input type="time" id="event-start-time" class="form-control" ng-model="\$ctrl.localEvent.startTime"
                  step="1" required />
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="event-end-date" class="form-label">End Date</label>
                <input type="date" id="event-end-date" class="form-control" ng-model="\$ctrl.localEvent.endDate"
                  required />
              </div>
              <div class="mb-3">
                <label for="event-end-time" class="form-label">End Time</label>
                <input type="time" id="event-end-time" class="form-control" ng-model="\$ctrl.localEvent.endTime" step="1"
                  required />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="event-priority" class="form-label">Priority</label>
            <input type="number" id="event-priority" class="form-control" ng-model="\$ctrl.localEvent.priority" min="1"
              required />
            <div class="form-text">Highest priority value takes precedence! Minimum 1.</div>
          </div>
          <div class="d-flex justify-content-between">
            <button type="button" class="btn btn-danger" ng-click="\$ctrl.delete()"
              ng-show="\$ctrl.localEvent.intervalId">
              <i class="fas fa-trash"></i> Delete </button>
            <div>
              <button type="button" class="btn btn-secondary me-2" ng-click="\$ctrl.cancel()">Cancel</button>
              <button type="submit" class="btn btn-primary">
                <i class="fas fa-save"></i> Save </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>`;
// Exports
export default code;